<template>
    <button
        class="button rounded-full flex items-center justify-center"
        :class="[
            getButtonTypeClasses(),
            sizeClass || 'w-[50px] h-[50px]',
            { Disabled: disabled }
        ]"
        :disabled="disabled"
        v-on:click="$emit('click')"
    >
        <span class="icon text-sm font-normal">
            <i :class="icon" class="fas fa-2x"></i>
        </span>
    </button>
</template>
<script setup lang="ts">
type ButtonType = 'Primary' | 'Secondary' | 'Critical';

interface Props {
    icon: string;
    disabled?: boolean;
    sizeClass?: string;
    buttonType?: ButtonType;
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false,
    buttonType: 'Primary',
    sizeClass: ""
});

const getButtonTypeClasses = () => {
    switch (props.buttonType) {
        case 'Primary':
            return 'bg-action text-inverse-emphasis';
        case 'Secondary':
            return 'bg-white text-action border-2 border border-action';
        case 'Critical':
            return 'bg-red-600 text-white';
        default:
            return 'bg-action text-inverse-emphasis';
    }
};

defineEmits(["click"]);
</script>